import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertSnackbarComponent } from './components/alert-snackbar.component';
import { DynamicIconDirectiveModule } from '@nai-libs/directives/dynamic-icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [CommonModule, DynamicIconDirectiveModule, MatSnackBarModule],
  declarations: [AlertSnackbarComponent],
  exports: [AlertSnackbarComponent],
})
export class AlertFeatureModule {}
